import PropTypes from 'prop-types';
import { headingPropTypes } from '@Theme/natucare/modules/Footer/components/Heading/HeadingPropTypes';
export const linksPropTypes = {
  heading: headingPropTypes.heading,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }))
};